import React, { useState } from "react";

const faqs = [
  {
    question: "¿Necesito experiencia previa para usar la plataforma?",
    answer:
      "No, PanamaBR está diseñado para aspirantes de todos los niveles. Desde principiantes hasta corredores que buscan actualizar sus conocimientos.",
    category: "general",
  },
  {
    question: "¿El contenido está actualizado con las últimas leyes?",
    answer:
      "Sí, actualizamos constantemente nuestro banco de preguntas y biblioteca legal con las últimas reformas.",
    category: "contenido",
  },
  {
    question: "¿Puedo cancelar mi suscripción en cualquier momento?",
    answer:
      "Sí, puedes cancelar tu suscripción cuando quieras. No hay contratos de permanencia.",
    category: "pagos",
  },
  {
    question: "¿El simulador es igual al examen real?",
    answer:
      "Sí, nuestro simulador replica exactamente el formato del examen oficial de la Junta Técnica de Corredores de Bienes Raíces de Panamá, incluyendo estructura, tiempo y tipo de preguntas.",
    category: "examen",
  },
  {
    question: "¿Ofrecen certificación oficial?",
    answer:
      "La plataforma te prepara para el examen oficial, pero la certificación final es emitida por la Junta Técnica.",
    category: "examen",
  },
  {
    question: "¿Puedo acceder desde mi teléfono?",
    answer:
      "Sí, PanamaBR es completamente responsive. Puedes estudiar desde cualquier dispositivo: computadora, tablet o smartphone.",
    category: "tecnico",
  },
  {
    question: "¿Hay soporte en caso de dudas?",
    answer:
      "Sí, ofrecemos soporte por email para todos los planes. Los planes premium cuentan con prioridad.",
    category: "soporte",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faq" className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-sm font-bold text-blue-600 uppercase tracking-wider">
            Preguntas Frecuentes
          </span>
          <h2 className="text-4xl md:text-5xl font-black mt-4 mb-6 bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent">
            Todo lo que necesitas saber
          </h2>
          <p className="text-xl text-slate-600">
            Respuestas a las dudas más comunes sobre PanamaBR.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border border-slate-200 overflow-hidden hover:border-blue-200 transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left"
              >
                <span className="font-bold text-slate-900 text-lg">
                  {faq.question}
                </span>
                <span
                  className={`ml-4 flex-shrink-0 w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center transition-all ${
                    openIndex === index ? "bg-blue-100 text-blue-600" : ""
                  }`}
                >
                  <svg
                    className={`w-5 h-5 transition-transform ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </span>
              </button>

              {openIndex === index && (
                <div className="px-6 pb-5 animate-slideDown">
                  <div className="pt-2 border-t border-slate-100">
                    <p className="text-slate-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
